<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "supplier",
      key: "id",
      kv: "",
      url: {},
      items: [
        { label: "新增客户信息", type: "header" },
        {
          label: "",
          name: "",
          value: "",
          type: "kong",
          rules: [{ required: false, trigger: "blur" }],
          onAddress: this.addres,
          onCancel: this.cancel,
        },
        {
          label: Number(customerId) == 0 ? "客户名称" : "供应商名称",
          name: "supplierName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: Number(customerId) == 0 ? "客户地址" : "供应商地址",
          name: "supplierAddress",
          value: "",
          type: "input",
          width: "400px",
        },

        {
          label: "项目",
          name: "projectIdList",
          value: "",
          type: "multiple",
          filterable: true,
          width: "400px",
          dropList: [],
        },
        // {
        //   label: "工单类型",
        //   name: "workTypeId",
        //   value: "",
        //   type: "select",
        //   width: "400px",
        //   dropList:[]
        // },
        {
          label: "状态",
          name: "state",
          value: 10,
          type: "select",
          width: "400px",
          rules: [{ required: true, trigger: "blur", type: "number" }],
          dropList: [
            {
              value: 12,
              name: "潜在",
            },
            {
              value: 1,
              name: "提需求",
            },
            {
              value: 2,
              name: "需求沟通",
            },
            {
              value: 3,
              name: "正式立项",
            },
            {
              value: 4,
              name: "预算申报",
            },
            {
              value: 5,
              name: "上会通过",
            },
            {
              value: 6,
              name: "院内谈判",
            },
            {
              value: 7,
              name: "公开调研",
            },
            {
              value: 8,
              name: "招投标",
            },
            {
              value: 9,
              name: "签订合同",
            },
            {
              value: 10,
              name: "服务中",
            },
            {
              value: 11,
              name: "lost",
            },
          ],
        },
        {
          label: "性质",
          name: "supplierNature",
          value: "",
          type: "select",
          width: "400px",
          dropList: [
            {
              value: 1,
              name: "厂家",
            },
            {
              value: 2,
              name: "代理",
            },
          ],
        },
        {
          label: "法人代表",
          name: "legalRepresentative",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "联系电话",
          name: "phone",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "注册资金(万元)",
          name: "registeredCapital",
          value: 1,
          type: "number",
          width: "200px",
          min: 1,
        },
        {
          label: Number(customerId) == 0 ? "客户规模" : "供应商规模",
          name: "supplierScale",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "项目经理",
          name: "projectManager",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "项目经理电话",
          name: "telephone",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "驻场人员",
          name: "userId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
        },
        {
          label: "综合评分",
          name: "comprehensiveServiceRating",
          value: 100,
          type: "number",
          width: "200px",
          max: 100,
          min: 0,
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "input",
          width: "400px",
        },
      ],
      forms: {},
    };
  },
  created() {
    // this.getWorkType();
    this.loaduserData();
    this.loadProject();
    let query = this.$route.query;
    if (query.action === "edit") {
      this.forms.id = query.kv;
      this.kv = query.kv;
      this.initData();
    }
    let obj = {
      label: "后台名称",
      name: "customerIdGroup",
      value: "",
      type: "selectDesk",
      width: "400px",
      dropList: [],
      selected: 0,
    };
    if (customerId == 0) {
      this.loadAdminUserData();
      this.items.splice(1, 0, obj);
    }
  },
  mounted() {},
  methods: {
    async loadAdminUserData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/customer/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.customerName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "customerIdGroup") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async loadProject() {
      this.content = "";
      let q = {
        status: 2,
      };
      let res = await $utils.api.load("/admin/system/management/listAll", q, "get");
      if (res.code == 200) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        console.log(dropList);

        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "projectIdList") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      $utils.api.load("/admin/system/maiUser/insList").then((res) => {
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "userId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    // async getWorkType() {
    //   let d = {}
    //   let res = await $utils.api.load("admin/system/workType/list", d, "get")
    //   if (res && res.rows) {
    //     let ll = res.rows
    //     let dropList = []
    //     for (let index = 0; index < ll.length; index++) {
    //       const element = ll[index]
    //       let xx = {}
    //       xx.value = element.id
    //       xx.name = element.name
    //       xx.children = element.children || []
    //       dropList.push(xx)
    //     }
    //     for (let index = 0; index < this.items.length; index++) {
    //       const element = this.items[index]
    //       if (element && element.name == 'workTypeId') {
    //         // this.items[index]['dropList'] = dropList
    //         this.items[index]['dropList'] = (this.items[index]['dropList'] || []).concat(dropList)
    //       }
    //     }
    //   }
    // },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/supplier/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.forms.id) {
            $utils.api
              .load(`/admin/system/supplier/edit`, q, "POST")
              .then((res) => {
                this.sloading = false;
                if (res.status) {
                  $utils.toast.success("保存成功");
                  $utils.url.go(-1);
                }
              })
              .catch((e) => {
                this.sloading = false;
                $utils.toast.error("保存异常" + e.message);
              });
          } else {
            $utils.api
              .load(`/admin/system/supplier/add`, q, "POST")
              .then((res) => {
                this.sloading = false;
                if (res.status) {
                  $utils.toast.success("保存成功");
                  $utils.url.go(-1);
                }
              })
              .catch((e) => {
                this.sloading = false;
                $utils.toast.error("保存异常" + e.message);
              });
          }
        }
      });
    },
  },
};
</script>
